import { defineComponent as _defineComponent } from 'vue'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import DangerRiskIcon from './DangerRiskIcon.vue'
import NormalRiskIcon from './NormalRiskIcon.vue'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import FireOubreakCardMenu from './FireOubreakCardMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import FireOutbreakCardReactionMenu from './FireOutbreakCardReactionMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakCard',
  props: {
    alert: null
  },
  emits: ["reaction", "shareTo", "focus"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'reaction', value: FireOutbreakReactionEnum): void
	(event: 'shareTo', value: ShareFireOutbreakAlertEnum): void
	(event: 'focus'): void
}), expose: any, slots: any, attrs: any }) {

const { alert } = __props as {
	alert: FireOutbreak
};





// Clique no card marca o alerta como visto e pede o zoom no foco. Cliques nos
// menus (compartilhar/avaliar) só marcam como visto: não devem mover o mapa.
function handleClick(event: MouseEvent) {
	alert.haveSeenAlert()
	if ((event.target as HTMLElement).closest('[data-card-menu]')) return
	emit('focus')
}

return { __sfc: true,emit, handleClick, DangerRiskIcon, NormalRiskIcon, FireOubreakCardMenu, FireOutbreakCardReactionMenu }
}

})